/** Frontend build-time gate; the backend capability flag remains authoritative. */
export const GEOMECHANICS_UI_ENABLED =
  String(import.meta.env.VITE_GEOMECHANICS_ENABLED).toLowerCase() === 'true';
